module.exports = __webpack_public_path__ + "4b45ea6ca28820fb1b43db899c4bb1df.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-320.webp
// module id = 202
// module chunks = 0